import React from 'react'
import moment from 'moment'
import styled from 'react-emotion'
import ActiveBooking from './ActiveBooking'

const Wrapper = styled('div')`
  margin-bottom: 10px;
`

export default ({ bookings }) => {
  if (!bookings) {
    return null
  }

  const sortedBookings = bookings.sort((a, b) =>
    moment(a.startDate).diff(moment(b.startDate), 'd')
  )

  return (
    <Wrapper>
      {sortedBookings.map((booking, index) => (
        <ActiveBooking
          key={`${booking.bookingNumber}-${index}`}
          booking={booking}
          isNextUpcomingTrip={index === 0}
        />
      ))}
    </Wrapper>
  )
}
